// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"IQ-z","categoryName":"JQ-z","categoryNameSearchHeader":"KQ-z","categoryContent":"LQ-z","bottomAligned":"MQ-z","image":"NQ-z","imageNoBackground":"OQ-z"};